import axios from "axios";
import Config from "src/config";

const v2_actionBuscarMensagens = (querys, data) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chats/mensagens${querys}`,
        data
    });
};

export default v2_actionBuscarMensagens;
